import { CartPolicy } from './types';
import { getAttr, pass } from './cartLineHelpers';

export const siblingIdIncrementPolicy: CartPolicy = (input) => {
  const hasSibling = (input.lineItemsToAdd ?? []).some((line) =>
    getAttr(line.attributes, 'sibling_id'),
  );
  return hasSibling
    ? pass(input, 'sibling line spawns a new line')
    : pass(input);
};
